// eslint-disable-next-line no-unused-vars
export const getRmaStatusViaId = (id?: number) => {
  return '--';
};

